module.exports = __webpack_public_path__ + "static/media/delishop_logo.1068cd1b.svg";